import { SummaryRow } from "../../../shared/result/ResultPrimitives";
import {
  formatDateTimeToLocale,
  formatKES,
  getDisplayValue,
} from "../../../../utils/transactionutils";

export function TransactionSummaryRows({
  transactionReference,
  createdDate,
  verifiedAlias,
  aliasLabel,
  accountNumber,
  transactionAmount,
  transactionFee,
  total,
  newBalance,
  balanceLabel = "Net Wallet Balance",
}) {
  return (
    <>
      {transactionReference && (
        <SummaryRow
          label="Transaction ID"
          value={transactionReference}
          stacked
        />
      )}
      {createdDate && (
        <SummaryRow label="Date" value={formatDateTimeToLocale(createdDate)} />
      )}
      <SummaryRow label={aliasLabel} value={getDisplayValue(verifiedAlias)} />
      {accountNumber && (
        <SummaryRow label="Account Number" value={accountNumber} />
      )}
      <SummaryRow label="Amount" value={formatKES(transactionAmount)} />
      <SummaryRow label="Transaction Fee" value={formatKES(transactionFee)} />
      <SummaryRow label="Total Deducted" value={formatKES(total)} bold />
      <SummaryRow label={balanceLabel} value={formatKES(newBalance)} />
    </>
  );
}
